<template>
<!-- eslint-disable -->
  <div>
    <div id="bc">
      <div v-for="(crumb,key) in breadcrumb">
        <div class="nextto" v-if="key + 1 == breadcrumb.length">
          <div class="nextto">{{ crumb.Crumb }}</div>
        </div>
        <div class="nextto" v-else="key + 1 != breadcrumb.length">
          <div class="nextto">
            <router-link style="text-decoration: none; color: inherit;"
                         :to="{ path: '/ShowProductsofCat', query: { id: crumb.CatID, level: crumb.Level, category: crumb.Crumb } }">
              {{ crumb.Crumb }}
            </router-link>
          </div>
          <div class="nextto" v-if="breadcrumb.length > 1"> / </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Comp_BreadCrumb',
    props: ['breadcrumb'],
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">

  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */

</style>
<style>
  .nextto {
    float: left;
    margin-right: 5px;
  }

  #bc {
    padding-left: 20px;
    padding-bottom: 20px;
  }

</style>




// WEBPACK FOOTER //
// src/Comp_BreadCrumb.vue